"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var SuccessIcon = function () { return (react_1.default.createElement("svg", { width: "70", height: "70", viewBox: "0 0 70 70", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("circle", { cx: "34.5", cy: "34.5", r: "34.5", fill: "#07C56B" }),
    react_1.default.createElement("path", { d: "M48.0899 27.1816L30.7192 43.9089L22.999 36.4746", stroke: "white", strokeWidth: "4.18182", strokeLinecap: "round", strokeLinejoin: "round" }))); };
exports.SuccessIcon = SuccessIcon;
//# sourceMappingURL=Success.js.map